<template>
  <div
    class="ccrs-search"
  >
    <h1
      class="h4"
    >
      {{ $tv('pageHeader', 'ccrs') }}
    </h1>
    <div
      class="ccrs-search-bar__container"
      v-click-outside="onClickOutside"
    >
      <ccrs-search-bar
        @search-term="getOverlay"
        :is-loading="isLoading"
        @open-overlay="showOverlay = !showOverlay"
      />
      <div class="ccrs-search-result-popup__container">
        <CcrsSearchResultsPopup
          v-if="showOverlay"
          @clickItem="clickItem"
          :search-results="searchResultsUnique"
          :search-term="searchTerm"
          @close-overlay="showOverlay = !showOverlay"
        />
      </div>
      <span
        class="info"
      >{{ $tv('searchInfoText', 'ccrs') }}</span>
    </div>
    <CcrsResultView
      v-show="chosenResults.length > 0"
      :search-results="chosenResults"
      :chosen-competitor="chosenResult"
      :search-term="searchTerm"
    />
  </div>
</template>
<script>
import {useCcrsService} from '@/composables/ccrs_service'
import CcrsResultView from '~/components/ccrs/CcrsResultView.vue'
import CcrsSearchBar from '~/components/ccrs/CcrsSearchBar'
import CcrsSearchResultsPopup from '~/components/ccrs/CcrsSearchResultsPopup'
import {storeToRefs} from 'pinia'
import {useUserStore} from '@/store/user'

export default {
  components: {CcrsSearchBar, CcrsSearchResultsPopup, CcrsResultView},
  setup() {
    const {includedBrandCodes} = storeToRefs(useUserStore())
    const {getCcrsSearch} = useCcrsService()
    return {
      includedBrandCodes,
      getCcrsSearch
    }
  },
  data() {
    return {
      searchResults: [],
      showOverlay: false,
      searchTerm: null,
      chosenResult: {
        ccrs_competitor: {Name: null},
        ccrs_competitordesign: {Name: null},
        category: {TechnicalName: null}
      },
      isLoading: false,
      similiarItems: []
    }
  },
  mounted() {
    useBreadcrumb(this.breadcrumbs)
  },
  methods: {
    handleSearchResults(payload) {
      if (Array.isArray(payload)) {
        this.searchResults = payload
      } else {
        this.searchResults = null
      }
    },
    handleSearchBarClicked() {
      if (this.searchResults.length > 0) {
        this.showOverlay = !this.showOverlay
      }
    },
    onClickOutside() {
      if (this.showOverlay) {
        this.showOverlay = false
      }
    },
    clickItem(payload) {
      this.similiarItems = []
      if (payload && payload['ccrs_competitordesign']) {
        this.chosenResult = payload
        if (this.chosenResult) {
          const index = this.searchResults.findIndex(i => i.item === this.chosenResult)
          this.trackResultClick(this.searchTerm, `${this.chosenResult?.ccrs_competitor?.Name} / ${this.chosenResult?.ccrs_competitordesign?.Name}`, index + 1)
        }
        this.showOverlay = false
      } else {
        this.chosenResult = null
      }
    },
    async getOverlay(value) {
      if (this.searchDebouncer) {
        clearTimeout(this.searchDebouncer)
      }

      this.searchDebouncer = setTimeout(async () => {
        this.isLoading = true
        if (value.length >= 1) {
          this.searchResults = null
          this.showOverlay = true
          const brands = this.$auth.loggedIn ? this.includedBrandCodes : ['F']
          const res = await this.getCcrsSearch(value, brands)
          // only emit result if its the last search
          if (res.query === value) {
            this.searchResults = res.items
            this.searchTerm = value
            if (res && res.items) {
              this.trackSearch(res.query, res.items.length)
            }
          }

        }
        else {
          this.showOverlay = false
          this.chosenResult = null
        }
        this.isLoading = false
      }, 100)
    },
    setSimilarItems(items) {
      if (this.searchResults && items?.length > 0) {
        this.similiarItems = items
      }
      return this.similiarItems
    },
    trackSearch(term, resultCount) {
      this.$gtm.trackEvent({
        event: 'ccrs_search',
        category: 'ccrs_search',
        action: 'ccrs_search',
        ecommerce: {
          'search_term': term,
          'hitcount': resultCount}
      })
    },
    trackResultClick(term, competitorDesign, index) {
      this.$gtm.trackEvent({
        event: 'ccrs_resultclick',
        category: 'ccrs_search',
        action: 'ccrs_resultclick',
        ecommerce: {
          'search_term': term,
          'ccrs_design': competitorDesign,
          'index': index}
      })
    }
  },
  computed: {
    chosenResults() {
      if (this.chosenResult && this.searchResults && this.searchResults?.length > 0) {
        const similiarItems = this.searchResults
          .map(t => t.item)
          .filter(a =>
            a.ccrs_competitordesign?.Name === this.chosenResult?.ccrs_competitordesign?.Name &&
            a.ccrs_competitor?.Name === this.chosenResult?.ccrs_competitor?.Name)
        return this.setSimilarItems(similiarItems)
      }
      return []
    },
    searchResultsUnique() {
      const uniqueList = []
      if (this.searchResults && Array.isArray(this.searchResults)) {
        this.searchResults.forEach(result => {
          if (uniqueList.findIndex(a =>
            result.item?.ccrs_competitor?.Name === a.item?.ccrs_competitor?.Name &&
            result.item?.ccrs_competitordesign?.Name === a.item?.ccrs_competitordesign?.Name) === -1) {
            if (this.chosenResult === result.item) {
              result.item = {...result.item, isSelected: true}
            }
            else {
              result.item = {...result.item, isSelected: false}
            }
            uniqueList.push(result)
          }
        })
        return {items: uniqueList}
      }
      return null

    },
    breadcrumbs() {
      return [{label: this.$tv('title', 'ccrs')}]
    }
  }
}
</script>

<style lang="scss">

.ccrs-search {
  min-height: 40rem;
  overflow: hidden;
  position: relative;

  h1 {
    margin-left: $default-margin-padding-2x;
    margin-bottom: 0;
  }

  .ccrs-search-bar__container {
    max-width: 40rem;
    padding: $default-margin-padding-2x $default-margin-padding-2x 0;
    position: relative;

    .info {
      color: $color__primary;
      font-weight: lighter;
      display: block;
      margin-top: $default-margin-padding-width;
    }

    .ccrs-search-result-popup__container {
      width: 100%;
      margin-top: -$default-margin-padding-width;
    }

    @include breakpoint-down($md) {
      .ccrs-search-bar__container {
        max-width: 100%;
      }
    }
  }
}

</style>
